import { createFileRoute } from '@tanstack/react-router';
import { HrPayrollPage } from '../../../../components/portals/hr/HrPayrollPage';

export const Route = createFileRoute('/portal/managers/hr/payroll')({
  component: HrPayrollPage,
});
